// extracted by mini-css-extract-plugin
export default {"error":"Error_error__59ucI","error-sec":"Error_error-sec__m7nLY","cica":"Error_cica__Dhmf8","content":"Error_content__mT5BL"};